import Carousel from 'react-bootstrap/Carousel';

import CastorOilShampoo from '../../Assets/Projects/HD/Castor-Oil-Shampoo.webp';
import CastorOilConditioner from '../../Assets/Projects/HD/Castor-Oil-Conditioner.webp';

function CarouselFadeCastor() {
  const customCarouselItemStyle = {
    display: 'flex',
    flexDirection: 'row', // Display in a row layout
    alignItems: 'center', // Center vertically
  };

  const customImageStyle = {
    marginRight: '10px', // Create some space between the image and caption
  };

  const customCaptionStyle = {
    flex: '1', // Take up remaining horizontal space

    borderBottomLeftRadius: '80px 80px',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    color: 'white',
    padding: '10px',
    marginLeft: '-50px',
    borderLeftRadius: '20rem', // Overlap the image slightly to the left
  };

  return (
    <Carousel fade controls={false} indicators={false}>
      <Carousel.Item style={customCarouselItemStyle}>
        <img
          src={CastorOilShampoo}
          alt=""
          width={200}
          height={300}
          className="image-border-glow-bl-gold border-rounded p-2 m-2"
          style={customImageStyle}
          loading="lazy"
        />
        <div style={customCaptionStyle}>
          <h3>Castor Oil Shampoo</h3>
          <p>
            Contains cold pressed castor oil ingredients to nourish and
            strengthen your hair
          </p>
        </div>
      </Carousel.Item>
      <Carousel.Item style={customCarouselItemStyle}>
        <img
          src={CastorOilConditioner}
          alt=""
          width={200}
          height={300}
          className="image-border-glow-bl-gold border-rounded p-2 m-2"
          style={customImageStyle}
          loading="lazy"
        />
        <div style={customCaptionStyle}>
          <h3>Castor Oil Conditioner</h3>
          <p>
            Contains cold pressed castor oil ingredients to nourish and
            strengthen your hair
          </p>
        </div>
      </Carousel.Item>
    </Carousel>
  );
}

export default CarouselFadeCastor;
